import React, { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import {
  TAvatarBorderColourVariant,
  TAvatarSizeVariant,
} from '../Avatar/avatarVariants';
import { TDropdownItem } from '../Dropdown/DropdownCore';
import AvatarDropdownMenuButton from './AvatarDropdownMenuButton';

export enum AvatarGroupStyleVariant {
  STACK = 'stack',
  GRID = 'grid',
}

export type AvatarGroupProps = {
  styleVariant?: AvatarGroupStyleVariant;
  hasMoreButton?: boolean;
  menuItems?: TDropdownItem[];
  sizeVariant?: TAvatarSizeVariant;
  borderColourVariant?: TAvatarBorderColourVariant;
};

const AvatarGroup: FunctionComponent<PropsWithChildren<AvatarGroupProps>> = ({
  styleVariant = AvatarGroupStyleVariant.STACK,
  sizeVariant = 'md',
  children,
}) => {
  const styleClasses = useMemo(() => {
    switch (styleVariant) {
      case AvatarGroupStyleVariant.GRID:
        return 'flex gap-4 flex-wrap';
      default:
        return 'flex -space-x-2 flex-wrap gap-y-2';
    }
  }, [styleVariant]);

  // Ensure all children Avatars receive the sizeVariant prop
  const sizedChildren = useMemo(
    () =>
      React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(
          child as React.ReactElement<{ sizeVariant: TAvatarSizeVariant }>,
          {
            sizeVariant,
          }
        );
      }),
    [children, sizeVariant]
  );

  return <div className={styleClasses}>{sizedChildren}</div>;
};

export default AvatarGroup;
export { AvatarDropdownMenuButton as DropdownMenuButton };
